var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIcon from '../APIcon';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { generateNumberRangeArray } from '../../../helpers/paginationHelper';
import './Pagination.css';
var PaginationComponent = function (_Component) {
  _inherits(PaginationComponent, _Component);
  function PaginationComponent() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, PaginationComponent);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationComponent.__proto__ || Object.getPrototypeOf(PaginationComponent)).call.apply(_ref, [this].concat(args))), _this), _this.getClasses = function () {
      return getBEMClasses(['pagination', _this.props.customClass + '-pagination']);
    }, _this.goToPage = function (event, page) {
      event.preventDefault();
      _this.props.setActivePage && _this.props.setActivePage(page);
    }, _this.renderNextButtons = function (page) {
      var paginationClasses = _this.getClasses();
      var disabled = _this.props.totalPages === 0 || page === _this.props.totalPages - 1;
      return React.createElement('span', {
        className: paginationClasses('next')
      }, React.createElement('a', {
        className: paginationClasses('text', {
          disabled: disabled
        }),
        onClick: function onClick(e) {
          return !disabled && _this.goToPage(e, page + 1);
        }
      }, _this.context.t('Next'), React.createElement(APIcon, {
        name: 'caretNext',
        customClass: paginationClasses('arrow', 'next')
      })), React.createElement('a', {
        className: paginationClasses('text', {
          disabled: disabled
        }),
        onClick: function onClick(e) {
          return !disabled && _this.goToPage(e, _this.props.totalPages - 1);
        }
      }, React.createElement(APIcon, {
        name: 'doubleCaretNext',
        customClass: paginationClasses('arrow', 'next')
      })));
    }, _this.renderPreviousButtons = function (page) {
      var paginationClasses = _this.getClasses();
      var disabled = _this.props.totalPages === 0 || page === 0;
      return React.createElement('span', {
        className: paginationClasses('previous')
      }, React.createElement('a', {
        className: paginationClasses('text', {
          disabled: disabled
        }),
        onClick: function onClick(e) {
          return !disabled && _this.goToPage(e, 0);
        }
      }, React.createElement(APIcon, {
        name: 'doubleCaretPrevious',
        customClass: paginationClasses('arrow', 'previous')
      })), React.createElement('a', {
        className: paginationClasses('text', {
          disabled: disabled
        }),
        onClick: function onClick(e) {
          return !disabled && _this.goToPage(e, page - 1);
        }
      }, React.createElement(APIcon, {
        name: 'caretPrevious',
        customClass: paginationClasses('arrow', 'previous')
      }), _this.context.t('Prev')));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(PaginationComponent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
        content = _props.content,
        activePage = _props.activePage,
        setActivePage = _props.setActivePage;
      var currentContent = content(activePage);
      if (activePage > 0 && currentContent.length === 0) {
        setActivePage(activePage - 1);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var paginationClasses = this.getClasses();
      var _props2 = this.props,
        activePage = _props2.activePage,
        totalPages = _props2.totalPages,
        maxPages = _props2.maxPages,
        showOnlyActivePage = _props2.showOnlyActivePage;
      var length = maxPages > totalPages ? totalPages : maxPages;
      var pages = generateNumberRangeArray(length, activePage, totalPages).map(function (i) {
        return React.createElement('a', {
          key: i,
          className: paginationClasses('page', activePage === i ? 'active' : null),
          onClick: function onClick(e) {
            return _this2.goToPage(e, i);
          }
        }, i + 1);
      });
      var content = this.props.content(activePage);
      return React.createElement('div', {
        className: this.props.containerClassName
      }, React.createElement('div', {
        className: paginationClasses('content')
      }, content), React.createElement('div', {
        className: paginationClasses('container')
      }, this.renderPreviousButtons(activePage), showOnlyActivePage ? React.createElement('div', {
        className: paginationClasses('pages')
      }, React.createElement('div', {
        className: paginationClasses('page')
      }, activePage + 1)) : React.createElement('div', {
        className: paginationClasses('pages')
      }, pages), this.renderNextButtons(activePage)));
    }
  }]);
  return PaginationComponent;
}(Component);
PaginationComponent.propTypes = {
  totalPages: PropTypes.number.isRequired,
  content: PropTypes.func.isRequired,
  activePage: PropTypes.number,
  containerClassName: PropTypes.string,
  componentName: PropTypes.string,
  customClass: PropTypes.string
};
PaginationComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
PaginationComponent.defaultProps = {
  activePage: 0,
  containerClassName: '',
  customClass: ''
};
export default PaginationComponent;